import React, { useState } from 'react';
import { Mail, Lock, LogIn, Building2, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

const BusinessLogin = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/api/business/auth/login`, formData);
      localStorage.setItem('business_token', response.data.token);
      localStorage.setItem('business_user', JSON.stringify(response.data));
      onLoginSuccess(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#2C2416] via-[#8B3A3A] to-[#2C2416] flex items-center justify-center p-4">
      <div className="bg-[#F5F0E1] rounded-lg shadow-2xl max-w-md w-full p-8 relative">
        {/* Back Button */}
        <a
          href="/"
          className="absolute top-4 left-4 p-2 hover:bg-[#E8E2D2] rounded-full transition-colors group"
          title="Back to Main Site"
        >
          <ArrowLeft size={24} className="text-[#2C2416] group-hover:text-[#8B3A3A]" />
        </a>
        
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-gradient-to-br from-[#8B3A3A] to-[#6B2A2A] rounded-full">
              <Building2 size={40} className="text-[#F5F0E1]" />
            </div>
          </div>
          <h1 className="font-heading text-3xl font-bold text-[#2C2416] mb-2">
            Business Portal
          </h1>
          <p className="font-utility text-sm text-[#2C2416]/70">
            Vigilante Radio Montana
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              {error}
            </div>
          )}

          {/* Email */}
          <div>
            <label className="block font-utility text-sm font-medium text-[#2C2416] mb-2">
              Email Address
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Mail size={18} className="text-[#2C2416]/40" />
              </div>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="pl-10 w-full px-4 py-3 border-2 border-[#2C2416]/20 rounded-lg focus:ring-2 focus:ring-[#8B3A3A] focus:border-transparent transition-all"
                placeholder="your-business@example.com"
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block font-utility text-sm font-medium text-[#2C2416] mb-2">
              Password
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock size={18} className="text-[#2C2416]/40" />
              </div>
              <input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="pl-10 w-full px-4 py-3 border-2 border-[#2C2416]/20 rounded-lg focus:ring-2 focus:ring-[#8B3A3A] focus:border-transparent transition-all"
                placeholder="••••••••"
              />
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-[#8B3A3A] to-[#6B2A2A] text-[#F5F0E1] py-3 px-6 rounded-lg font-utility font-bold uppercase tracking-wide hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#F5F0E1]"></div>
                Signing In...
              </>
            ) : (
              <>
                <LogIn size={20} />
                Sign In
              </>
            )}
          </button>
        </form>

        {/* Help Text */}
        <div className="mt-6 text-center">
          <p className="font-utility text-xs text-[#2C2416]/60">
            Need access? Contact Vigilante Radio Montana admin
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessLogin;
